import { render } from "./exam-category.vue?vue&type=template&id=ba63b23e&scoped=true"
import script from "./exam-category.vue?vue&type=script&lang=js"
export * from "./exam-category.vue?vue&type=script&lang=js"

import "./exam-category.vue?vue&type=style&index=0&id=ba63b23e&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba63b23e"]])

export default __exports__